const grokEyeZonesList = [
  {
    id: "zone-01",
    name: "Zone 1",
    instruments: [
      {
        id: "instrument-01",
        indicator: "event",
        name: "Environment Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Environment Sensor #1",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "20°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "40%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "16Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "200",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "106µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "70dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "10hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "60%",
                icon: "light",
              },
            ],
          },
          {
            indicator: "null",
            name: "Environment Sensor #2",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "33°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "65%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "28Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "300",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "120µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "43dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "12hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "93%",
                icon: "light",
              },
            ],
          },
          {
            indicator: "null",
            name: "Environment Sensor #3",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "40°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "80%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "34Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "151",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "16µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "38dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "15hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "48%",
                icon: "light",
              },
            ],
          },
          {
            indicator: "null",
            name: "Environment Sensor #4",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "50°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "62%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "27Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "210",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "111µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "54dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "17hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "52%",
                icon: "light",
              },
            ],
          },
          {
            indicator: "null",
            name: "Environment Sensor #8",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "60°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "70%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "13Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "125",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "156µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "43dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "06hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "49%",
                icon: "light",
              },
            ],
          },
          {
            indicator: "null",
            name: "Environment Sensor #9",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "54°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "80%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "24Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "178",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "119µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "52dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "17hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "58%",
                icon: "light",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-02",
        indicator: "alert",
        name: "Flood Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Flood Sensor #1",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "64°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "60%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.38mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "62%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #2",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "71°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "69%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.42mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "72%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #3",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "25°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "40%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.28mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "75%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #4",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "35°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "40%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.58mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "61%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #5",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "57°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "60%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.30mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "72%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #6",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "63°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "87%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.18mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "60%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #15",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "64°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "60%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.38mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "65%",
                icon: "battery",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-14",
        indicator: "alert",
        name: "AI Camera",
        sensors: [
          {
            indicator: "event",
            name: "AI Camera #1",
            bodySectionItems: [
              {
                label: "Incidents",
                value: "32 min ago",
                icon: "incident",
              },
              {
                label: "Motion",
                value: "5 sec ago",
                icon: "motion",
              },
              {
                label: "Operation Alert",
                value: "3 days ago",
                icon: "operations",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "zone-02",
    name: "Zone 2",
    instruments: [
      {
        id: "instrument-44",
        indicator: "alert",
        name: "Flood Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Flood Sensor #14",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "64°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "60%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.38mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "65%",
                icon: "battery",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-13",
        indicator: "alert",
        name: "AI Camera",
        sensors: [
          {
            indicator: "event",
            name: "AI Camera #2",
            bodySectionItems: [
              {
                label: "Incidents",
                value: "12 min ago",
                icon: "incident",
              },
              {
                label: "Motion",
                value: "25 sec ago",
                icon: "motion",
              },
              {
                label: "Operation Alert",
                value: "1 day ago",
                icon: "operations",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "zone-03",
    name: "Zone 3",
    instruments: [
      {
        id: "instrument-03",
        indicator: "alert",
        name: "Flood Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Flood Sensor #7",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "71°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "70%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.33mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "69%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #13",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "63°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "60%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.28mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "71%",
                icon: "battery",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-12",
        indicator: "alert",
        name: "AI Camera",
        sensors: [
          {
            indicator: "event",
            name: "AI Camera #3",
            bodySectionItems: [
              {
                label: "Incidents",
                value: "42 min ago",
                icon: "incident",
              },
              {
                label: "Motion",
                value: "35 sec ago",
                icon: "motion",
              },
              {
                label: "Operation Alert",
                value: "2 days ago",
                icon: "operations",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "zone-04",
    name: "Zone 4",
    instruments: [
      {
        id: "instrument-04",
        indicator: "alert",
        name: "Environment Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Environment Sensor #5",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "25°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "40%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "36Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "551",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "136µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "70dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "10hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "60%",
                icon: "light",
              },
            ],
          },
          {
            indicator: "null",
            name: "Environment Sensor #6",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "48°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "90%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "46Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "251",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "16µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "58dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "08hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "73%",
                icon: "light",
              },
            ],
          },
          {
            indicator: "null",
            name: "Environment Sensor #7",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "17°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "68%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "18Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "211",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "26µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "52dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "14hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "68%",
                icon: "light",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-05",
        indicator: "alert",
        name: "Flood Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Flood Sensor #8",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "48°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "54%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.23mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "73%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #12",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "76°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "75%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.48mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "64%",
                icon: "battery",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-11",
        indicator: "alert",
        name: "AI Camera",
        sensors: [
          {
            indicator: "event",
            name: "AI Camera #4",
            bodySectionItems: [
              {
                label: "Incidents",
                value: "12 min ago",
                icon: "incident",
              },
              {
                label: "Motion",
                value: "35 sec ago",
                icon: "motion",
              },
              {
                label: "Operation Alert",
                value: "1 day ago",
                icon: "operations",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "zone-05",
    name: "Zone 5",
    instruments: [
      {
        id: "instrument-06",
        indicator: "alert",
        name: "Environment Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Environment Sensor #10",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "45°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "68%",
                icon: "humidity",
              },
              {
                label: "Carbon Monoxide",
                value: "16Kg",
                icon: "co2",
              },
              {
                label: "VOC ‘S",
                value: "231",
                icon: "voc",
              },
              {
                label: "Particulates",
                value: "116µg/m³",
                icon: "particulates",
              },
              {
                label: "Noise",
                value: "69dBA",
                icon: "noise",
              },
              {
                label: "Pressure",
                value: "13hPa",
                icon: "pressure",
              },
              {
                label: "Light",
                value: "67%",
                icon: "light",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-07",
        indicator: "alert",
        name: "Flood Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Flood Sensor #10",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "62°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "58%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "1.00mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "84%",
                icon: "battery",
              },
            ],
          },
          {
            indicator: "null",
            name: "Flood Sensor #11",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "69°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "78%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.38mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "71%",
                icon: "battery",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-10",
        indicator: "alert",
        name: "AI Camera",
        sensors: [
          {
            indicator: "event",
            name: "AI Camera #5",
            bodySectionItems: [
              {
                label: "Incidents",
                value: "42 min ago",
                icon: "incident",
              },
              {
                label: "Motion",
                value: "355 sec ago",
                icon: "motion",
              },
              {
                label: "Operation Alert",
                value: "2 days ago",
                icon: "operations",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: "zone-06",
    name: "Zone 6",
    instruments: [
      {
        id: "instrument-08",
        indicator: "alert",
        name: "Flood Sensors",
        sensors: [
          {
            indicator: "alert",
            name: "Flood Sensor #14",
            bodySectionItems: [
              {
                label: "Temperature",
                value: "58°C",
                icon: "temperature",
              },
              {
                label: "Humidity",
                value: "60%",
                icon: "humidity",
              },
              {
                label: "Water Level",
                value: "0.38mm",
                icon: "waterlevel",
              },
              {
                label: "Rainfall",
                value: "551mm",
                icon: "rainfall",
              },
              {
                label: "Battery",
                value: "87%",
                icon: "battery",
              },
            ],
          },
        ],
      },
      {
        id: "instrument-09",
        indicator: "alert",
        name: "AI Camera",
        sensors: [
          {
            indicator: "event",
            name: "AI Camera #6",
            bodySectionItems: [
              {
                label: "Incidents",
                value: "32 min ago",
                icon: "incident",
              },
              {
                label: "Motion",
                value: "5 sec ago",
                icon: "motion",
              },
              {
                label: "Operation Alert",
                value: "1 day ago",
                icon: "operations",
              },
            ],
          },
        ],
      },
    ],
  },
];

export default grokEyeZonesList;
